import React, { useEffect, useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import imgLogin from '../../assets/images/login.svg';
import logo from '../../assets/images/logo.svg';
import imgPlant from '../../assets/images/plant.svg';
import { resetPassword } from '../../actions/auth';
import ResetPwdForm from '../../components/form/AuthForm/ResetPwdForm';

import styles from './reset-password.module.scss';

const ResetPassword = () => {
  const authReducer = useSelector((d: any) => d.authReducer);
  const { t } = useTranslation('auth');
  const [succeed, setSucceed] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (authReducer.user?._id) navigate('/');
  }, [authReducer.user]);

  function submitReset(data: FieldValues) {
    resetPassword(dispatch, {
      password: data.password,
      token: params?.token || '',
    }).then((res: any) => {
      if (res?.status === 200) setSucceed(true);
    });
  }

  return (
    <div className={styles['reset-password']}>
      <div className={styles.picture}>
        <div className={styles.mobile}>
          <img src={imgPlant} alt="login" />
          <p>{t('login.welcome')}</p>
          <h2>{t('login.start1')}<br/>{t('login.start2')}</h2>
        </div>
        <div className={styles.desktop}>
          <div className={styles.logo}>
            <img src={logo} alt="login" />
          </div>
          <img src={imgLogin} alt="login" />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.form}>
          <h3>{t('reset.change')}</h3>
          <ResetPwdForm
            submit={submitReset}
            signinLink={succeed ? '/' : null}
            succeedMessage={
              succeed ? t('reset.success') : null
            }
            errorMessage={authReducer.error}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
